export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";